/*
 *
 * ChatDocumentationIndex actions
 *
 */

import {
  GET_INDEX_STATUS,
  GET_INDEX_STATUS_ERROR,
  GET_INDEX_STATUS_SUCCESS,
  SYNC_INDEX,
  SYNC_INDEX_ERROR,
  SYNC_INDEX_PROGRESS,
  SYNC_INDEX_SUCCESS,
} from './constants'

export const getIndexStatus = () => ({ type: GET_INDEX_STATUS })
export const getIndexStatusSuccess = ({ status }) => ({
  type: GET_INDEX_STATUS_SUCCESS,
  status,
})
export const getIndexStatusError = (error) => ({
  type: GET_INDEX_STATUS_ERROR,
  error,
})

export const syncIndex = () => ({ type: SYNC_INDEX })
export const syncIndexProgress = ({ pagesRemaining }) => ({
  type: SYNC_INDEX_PROGRESS,
  pagesRemaining,
})
export const syncIndexSuccess = () => ({ type: SYNC_INDEX_SUCCESS })
export const syncIndexError = (error) => ({ type: SYNC_INDEX_ERROR, error })
